module.exports = __webpack_public_path__ + "static/OCSP-logo-6714511e3cbebf03fa8d3b3cb322fd01.png";